import { Vehicle } from "../store/actions/vehicles";

export class VehicleHelper {
    static getTitle = (vehicle?: Vehicle) => {
        return vehicle ? [vehicle.model_year, vehicle.make, vehicle.model].join(' ').trim() : '';
    }
}